export const HOME = "/";
export const ROLES = "/roles";
export const SIGN_IN = "/";
export const SIGNED_OUT = "/";
